export { templateStore as store } from './reducers'
